/*
 * @Author: zhaoliang
 * @Date: 2023-04-24 15:36:17
 * @LastEditTime: 2023-04-28 14:49:39
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Login/tipsConfig.js
 *
 */
export const step1TipsConfig = [
  {
    title: 'login-step1-helptext-title-1',
    description: 'login-step1-helptext-desc-1',
  },
  {
    title: 'login-step1-helptext-title-2',
    description: 'login-step1-helptext-desc-2',
    linktext: 'views-bo-all-benefit-desc2',
    enurl: 'https://visaairportcompanion.ca/terms?lang=en',
    frurl: 'https://visaairportcompanion.ca/terms?lang=fr',
  },
];

export const step2TipsConfig1 = [
  {
    title: 'login-step2-helptext-title-1',
    description: 'login-step2-helptext-desc-1',
  },
  {
    title: 'login-step2-helptext-title-2',
    description: 'login-step2-helptext-desc-2',
  },
  {
    title: 'login-step2-helptext-title-3',
    description: 'login-step2-helptext-desc-3',
  },
  {
    title: 'login-step2-helptext-title-4',
    description: 'login-step2-helptext-desc-4',
  },
];

export const step2TipsConfig2 = [
  {
    title: 'login-step2-helptext-title-5',
    description: 'login-step2-helptext-desc-5',
  },
  {
    title: 'login-step2-helptext-title-2',
    description: 'login-step2-helptext-desc-2',
  },
  {
    title: 'login-step2-helptext-title-3',
    description: 'login-step2-helptext-desc-3',
  },
  {
    title: 'login-step2-helptext-title-4',
    description: 'login-step2-helptext-desc-4',
  },
];

export const step3TipsConfig = [
  {
    title: 'login-step3-helptext-title-1',
    description: 'login-step3-helptext-desc-1',
  },
  {
    title: 'login-step3-helptext-title-2',
    description: 'login-step3-helptext-desc-2',
  },
];
